import { myWalletClickHelper } from 'reaxl-analytics-handlers';

const sendGoogleClickPaymentEvent = (data, option) => {
    const { text, clickType, listingPosition } = data;
    myWalletClickHelper({
        eventResult: `text-link::open::${text}`,
        eventData: {
            vehicle: {
                clickType,
                listingPosition,
            },
        },
    }, option);
};

/**
 * @summary Sends Adobe Click event
 * @cmp view_pymt_dtl
 * @data inventoryId, filterDuck
 * @events event1
 */
export async function inventoryPaymentDetailsClick({
    data = {},
}, option) {

    const { par, clickType = '', paginatedListingIndex = '' } = data;

    const cmp = par.includes('spv') ? 'view_pymt_dtl_spv' : 'view_pymt_dtl';

    sendGoogleClickPaymentEvent({ text: 'see-payment-details', clickType, listingPosition: paginatedListingIndex }, option);

    // return data for custom event
    return { cmp };
}
